export default "__VITE_ASSET__HOK2IQTv__"